import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import { useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import { MemoizedButton } from "../../SDK/button";
import { myScroll } from "../../utils/myScroll";

const CustomStoreVehicleCards = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  maxHeight: "600px",
  maxWidth: "400px",
  padding: "20px",
  flexDirection: "column",
  background:
    "linear-gradient(180deg, rgba(53, 191, 104, 0.132) 0%, rgba(255, 255, 255, 0) 100%)",
  borderRadius: "0.5em",

  ".grid-item-style": {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  ".grid-container-style": {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "8px",
    marginBottom: "8px",

    // margin:'20px'
  },

  ".vehicleName": {
    fontSize: "14px",
    fontWeight: "600",
    margin: "8px",
  },

  ".vehicleDetails": {
    background: primary.white,
    borderRadius: "8px",
    padding: "16px",
  },

  ".vehicleDetailsHeader": {
    fontSize: "12px",
    color: primary.greyText,
  },
  ".vehicleDetailsdata": {
    fontSize: "18px",
    fontWeight: "900",
    textAlign: "center",
  },

  ".subHeader": {
    fontSize: "14px",
    fontWeight: "500",
    color: primary.mainText,
    marginTop: "8px",
  },

  ".subHeaderDetails": {
    fontSize: "24px",
    fontWeight: "600",
    // color: primary.mainGreen,
    marginBottom: "8px",
    color: primary.mainText,
  },
  ".visitStoreCta": {
    width: "90%",
    display: "flex",
    justifyContent: "center",
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    borderRadius: "8px",
    boxShadow: "none",
    background: primary.white,
    color: primary.main,
    border: `1px solid ${primary.main}`,
  },

  ".testDriveCta": {
    width: "90%",
    display: "flex",
    justifyContent: "center",
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    //background: primary.mainGreen,
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      color: primary.white,
      background: primary.main,
    },
  },

  [theme.breakpoints.down("md")]: {
    // maxWidth: "400px",
    width: "100% !important",
    padding: "12px",

    ".subHeader": {
      fontSize: "12px",
    },
    ".subHeaderDetails": {
      fontSize: "24px",
    },

    ".vehicleName": {
      fontSize: "14px",
    },
  },
}));

const StoreVehicleCards = ({ vehicleData }) => {
  const { showCarouselPopup } = useContext(Context);
  return (
    <CustomStoreVehicleCards>
      <Grid Container className="grid-container-style">
        <Grid item xs={8} className="grid-item-style">
          <Stack sx={{ maxWidth: { xs: "200px" } }}>
            <LazyLoadImage src={vehicleData?.storeImage} alt={vehicleData?.vehicle_name} />
          </Stack>
        </Grid>
        <Grid item xs={4} className="grid-item-style" flexDirection={"column"}>
          <Stack sx={{ maxWidth: "100px" }}>
            <LazyLoadImage src={vehicleData?.vehicle_logo} alt={vehicleData?.vehicle_name}/>
          </Stack>

          <Stack>
            <Typography className="subHeader">Ex Showroom Price</Typography>
            <Typography className="subHeaderDetails">
              ₹ {vehicleData?.prices["Others"]?.pickup?.price} L
            </Typography>
          </Stack>

          <Stack>
            <Typography className="subHeader">Emi Start From</Typography>
            <Typography className="subHeaderDetails">
              {" "}
              ₹ {vehicleData?.prices["Others"]?.pickup?.emiPrice}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <Typography className="vehicleName">
        {vehicleData?.vehicle_name}
      </Typography>

      <Grid Container className="grid-container-style">
        <Grid item xs={4} className="grid-item-style">
          {" "}
          <Stack className="vehicleDetails">
            <Typography className="vehicleDetailsHeader">🛣️ Range</Typography>
            <Typography className="vehicleDetailsdata">
              {vehicleData?.range}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={4} className="grid-item-style">
          {" "}
          <Stack className="vehicleDetails">
            <Typography className="vehicleDetailsHeader"> 🏋️ Load</Typography>
            <Typography className="vehicleDetailsdata">
              {vehicleData?.load}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={4} className="grid-item-style">
          {" "}
          <Stack className="vehicleDetails">
            <Typography className="vehicleDetailsHeader">
              {" "}
              🚗💨 Speed
            </Typography>
            <Typography className="vehicleDetailsdata">
              {vehicleData?.topSpeed}
            </Typography>
          </Stack>
        </Grid>
      </Grid>

      <Grid
        Container
        className="grid-container-style"
        spacing={2}
        justifyContent="space-between"
      >
        <Grid
          item
          xs={6}
          className="grid-item-style"
          rowSpacing={1}
          columnSpacing={1}
        >
          <MemoizedButton
            className="visitStoreCta"
            idlocal={`visitStore`}
            content={`Visit Store`}
            handleClick={() => {
              myScroll(
                0,
                document.getElementById("book-ticket").offsetTop - 100,
                "smooth"
              );
            }}
          />
        </Grid>
        <Grid
          item
          xs={6}
          className="grid-item-style"
          rowSpacing={1}
          columnSpacing={1}
        >
          <MemoizedButton
            className="testDriveCta"
            idlocal={`bookTestDrive`}
            content={`Book Test Drive`}
            handleClick={() => {
              showCarouselPopup();
              // myScroll(
              //   0,
              //   document.getElementById("book-ticket").offsetTop - 100,
              //   "smooth"
              // );
            }}
          />
        </Grid>
      </Grid>
    </CustomStoreVehicleCards>
  );
};

export default StoreVehicleCards;
